<div class="popup-overlay">
  <div class="popup-container">

    <!-- Header -->
    <div class="popup-header">
      <h2>⚠️ Regenerate Report</h2>
      <span class="close-btn" (click)="closePopup()">×</span>
    </div>

    <!-- Body -->
    <div class="popup-body">
      <p class="message">
        You are about to regenerate the report for the same ECOSP data.  
        Please select a version to continue.
      </p>

      <!-- Version Selection -->
      <div class="version-section">
        <label class="section-label">Select Version</label>

        <div class="version-options">
          <label class="radio-card" [class.active]="selectedVersion === '1'">
            <input type="radio" name="version" (change)="selectVersion('1')" checked>
            <span>Version 1</span>
          </label>

          <label class="radio-card" [class.active]="selectedVersion === '2'">
            <input type="radio" name="version" (change)="selectVersion('2')">
            <span>Version 2</span>
          </label>

          <label class="radio-card" [class.active]="selectedVersion === '3'">
            <input type="radio" name="version" (change)="selectVersion('3')">
            <span>Version 3</span>
          </label>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="popup-footer">
      <button class="btn cancel" (click)="closePopup()">Cancel</button>
      <button class="btn confirm" (click)="confirm()">Generate Report</button>
    </div>

  </div>
</div>